import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const CreditCardIcon = ({ color = '#B5BCBD', size = 24, ...props }) => (
  <svg
    viewBox="0 0 24 19"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21.996 0H2.004A1.993 1.993 0 0 0 0 1.984V16.53c0 1.095.896 1.983 2.004 1.983h19.992A1.993 1.993 0 0 0 24 16.531V1.984A1.993 1.993 0 0 0 21.996 0zM2.254 1.984h19.492a.25.25 0 0 1 .25.248v1.735H2.004V2.232a.25.25 0 0 1 .25-.248zM21.746 16.53H2.254a.25.25 0 0 1-.25-.248V9.257h19.992v7.026a.25.25 0 0 1-.25.248zM8 12.398v1.653a.5.5 0 0 1-.5.496h-3a.5.5 0 0 1-.5-.496v-1.653a.5.5 0 0 1 .5-.496h3a.5.5 0 0 1 .5.496zm8 0v1.653a.5.5 0 0 1-.5.496H9.833a.5.5 0 0 1-.5-.496v-1.653a.5.5 0 0 1 .5-.496H15.5a.5.5 0 0 1 .5.496z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
);

CreditCardIcon.propTypes = propTypes;

export default CreditCardIcon;
